<template>
  <div class="content">

    <div class="scan-drop-wrapper" v-if="files == null">
      <h1>Skanuj fakturę</h1>
      <div class="box" style="width: 100%">
        <app-drop @files="uploadFiles"></app-drop>
      </div>
      <br>
    </div>

    <div class="scan-area" v-if="filesFetched">
      <div class="form-area">
        <app-preview class="sticky" :lines="lines" :image="image"></app-preview>
      </div>

      <div class="form-area">
        <app-add-invoice ref="form"  :value="form" @input="getFormData"></app-add-invoice>
        <button class="btn btn--margined btn--gradient" @click="save">Zapisz</button>
      </div>
    </div>

    <app-loading :active="loading"></app-loading>
  </div>
</template>

<script>
import Preview from '@/components/scan/ScanPreview.vue'
import Drop from '@/components/scan/ScanDrop.vue'
import Loading from '@/components/Loading.vue'
import AddInvoice from '@/components/AddInvoiceForm.vue'

import { api } from "@/api.js";

export default {
  name: "scan",
  components: {
    AppPreview: Preview,
    AppAddInvoice: AddInvoice,
    AppDrop: Drop,
    AppLoading: Loading
  },
  data() {
    return {
      lines: [],
      image: null,
      files: null,
      filesFetched: false,
      loading: false,
      form: {
        name: '',
        invoice: {
          place: '',
          creation_date: '',
          sell_date: '',
          to: {
            nip: ''
          },
          from: {
            nip: ''
          }
        }
      }
    }
  },
  methods: {
    async uploadFiles(files) {
      this.files = files

      const formData = new FormData()
      formData.append('file', this.files[0])

      this.loading = true
      const response = await api.post("/ocr/invoice", formData, {
        config: { headers: {'Content-Type': 'multipart/form-data' }}
      });
      this.loading = false
      console.log(response)
      
      this.lines = response.data[0].lines
      this.image = response.data[0].file

      console.log(response.data[0].invoice);

      this.form = response.data[0]
      
      this.$refs.form.setData(this.form)

      console.log(response.data)
      this.filesFetched = true
    },
    getFormData(data) {
      for(let key in data) this.form[key] = data[key];
    },
    save() {
      console.log(this.form)
    }
  },
  metaInfo: {
    title: 'Skanowanie'
  }
}
</script>


<style lang="scss" scoped>
  .scan-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 32px;
    position: relative;
  }

  .scan-drop-wrapper {
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;

    .btn {
      width: 60%;
    }
  }

  .form-area {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .sticky {
    position: sticky;
    top: 80px;
  }
</style>
